import {
  Box,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Modal, 
  Typography, 
  IconButton
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetUserCountries,
  setState,
  getScenariosForCountry,
  getPeriods,
  getScenarioAuditReport,
  ExportAuditData
} from "./auditSlice";
import CustomButton from "../../components/ui/CustomButton";
import Alert from "../../components/ui/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { DataGrid } from "@mui/x-data-grid";
import InfoIcon from "@mui/icons-material/Info";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";

const ModificationInScenario = () => {
  const dispatch = useDispatch();
  const audit = useSelector((state) => state.audit);
  const {
    countries,
    selectedCountry,
    selectedCountryID,
    scenarios,
    periods,
    selectedPeriod,
    selectedScenarioID,
    showScenarioAuditData,
    isLoading,
    scenarioAuditReports,
    auditSKUCustomerLogs,
    showOrHideExport,
    selectedScenarioName
  } = audit;

  const [validate, setValidate] = useState({
    countryValidated: false,
    scenarioValidated: false,
    periodValidated: false
  });

  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: ""
  });
  const [openModal, setOpenModal] = useState(false);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [infoColumn, setInfoColumn] = useState("");

  //Handle InfoIcon click
  const handleInfoClick = (scenarioId, sectionId,period, type) => {
    //Filter auditSKUCustomerLogs based on scenarioId & sectionId
    const filteredData = auditSKUCustomerLogs?.filter(
      (log) => log.scenarioId === scenarioId && log.sectionId === sectionId && log.updatedDate === period
    );

    setFilteredLogs(filteredData);
    setModalTitle(type === "previous" ? "Previous Value" : "Modified Value");
    if(type === "previous"){
      setInfoColumn("previous");
    }
    else{
      setInfoColumn("modified");
    }
    setOpenModal(true);
  };

  //close function for the modal
  const handleClose = () => {
    setOpenModal(false);
  };

  const generateExportData = () => {
    return scenarioAuditReports.map((entry) => {
      const hasPreviousTruncated = entry.previousValue?.endsWith("...");
      const hasModifiedTruncated = entry.modifiedValue?.endsWith("...");
  
      if (hasPreviousTruncated || hasModifiedTruncated) {
        
        const matchingLogs = auditSKUCustomerLogs.filter(
          (log) => log.scenarioId === entry.scenarioId && log.sectionId === entry.sectionId && log.updatedDate === entry.period
        );
  
        
        const fullPreviousValue = hasPreviousTruncated
          ? matchingLogs.map((log) => log.previousValue).filter(val=>val).join(",")
          : entry.previousValue;
  
        const fullModifiedValue = hasModifiedTruncated
          ? matchingLogs.map((log) => log.modifiedValue).filter(val=>val).join(",")
          : entry.modifiedValue;
  
        return {
          ...entry,
          previousValue: fullPreviousValue,
          modifiedValue: fullModifiedValue,
        };
      }
  
      return entry;
    });
  };


  const columns = [
    { field: "scenarioName", headerName: "Scenario Name", flex: 0.7 },
    { field: "period", headerName: "Date(DDMMYYYY HH:MM:SS)", flex: 0.7,headerClassName: "wrapHeader" },
    { field: "section", headerName: "Section Modified", flex: 0.7 },
    { field: "attributeName", headerName: "Attributes/Fields Modified", flex: 1 },
    { field: "previousValue", headerName: "Previous Value", flex: 2,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <span>{params.value}</span>
          {params.value?.endsWith("...") && (
           <IconButton onClick={() => handleInfoClick(params.row.scenarioId, params.row.sectionId,params.row.period, "previous")}>
           <InfoIcon sx={{ fontSize: 22, color: "gray" }} />
           </IconButton>
          )}
        </div>
      ),

     },
    { field: "modifiedValue", headerName: "Modified Value", flex: 2,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <span>{params.value}</span>
          {params.value?.endsWith("...") && (
            <IconButton onClick={() => handleInfoClick(params.row.scenarioId, params.row.sectionId,params.row.period, "modified")}>
            <InfoIcon sx={{ fontSize: 22, color: "gray" }} />
            </IconButton>
          )}
        </div>
      ),
     },
  ];

  useEffect(() => {
    dispatch(setState("showScenarioAuditData", false));
    dispatch(setState("selectedCountry", ""));
    dispatch(setState("selectedCountryID", ""));
    dispatch(setState("selectedScenarioName", ""));
    dispatch(setState("selectedScenarioID", ""));
    dispatch(setState("selectedPeriod", ""));
    dispatch(setState("scenarios",[]));
    dispatch(GetUserCountries({ method: "Get" }));
    dispatch(getPeriods());
    dispatch(setState("showOrHideExport",false));
  }, []);

  useEffect(() => {
    if (selectedCountryID !== "") {
      //console.log("The selected countryid is", selectedCountryID);
      getScenarios();
    }
  }, [selectedCountryID]);

  function  getScenarios() {
    const countryID = selectedCountryID;
     dispatch(getScenariosForCountry({ countryID }));
  }

  useEffect(() => {
    const isAnyKeyValueFalse = (o) => !!Object.keys(o).find((k) => !o[k]);
    if (isAnyKeyValueFalse(validate)) {
      setAlert({ ...alert, alertDisplay: false });
    }
  }, [validate]);

  const displayAlert = (severityType) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: true,
      alertMessage: `Please select the ${severityType}`
    });
  };

  const setCountry = (event) => {
    dispatch(setState("showScenarioAuditData", false));
    dispatch(setState("selectedScenarioName", ""));
    dispatch(setState("selectedScenarioID", ""));
    dispatch(setState("selectedPeriod", ""));
   
    const name = event.target.value;
    const countryID = countries.find((country) => country.countryName === name).countryID;
   
    if (name) {
      setValidate({ ...validate, countryValidated: true });
    }
   
    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  };

  const setScenario = (event) => {
    dispatch(setState("showScenarioAuditData", false));
    const name = event.target.value;
    const selectedScenario = scenarios.find((scenario) => scenario.scenarioID === name);
   
    //console.log("The selected scenario is", selectedScenario);
   
    if (selectedScenario) {
      setValidate({ ...validate, scenarioValidated: true });
    }
   
    dispatch(setState("selectedScenarioName", selectedScenario.scenarioName));
    dispatch(setState("selectedScenarioID", selectedScenario.scenarioID));
  };

  const setPeriod = (event) => {
    dispatch(setState("showScenarioAuditData", false));
    const period = event.target.value;
   
    if (period) {
      setValidate({ ...validate, periodValidated: true });
    }
   
    dispatch(setState("selectedPeriod", period));
  };

  const handleDisplay = () => {
    const obj = {
      scenarioID: selectedScenarioID,
      period: selectedPeriod
    };
   
    //console.log("The object inside search is", obj);
   
    if (!validate.countryValidated) {
      displayAlert("Country");
    } else if (!validate.scenarioValidated) {
      displayAlert("Scenario");
    } else if (!validate.periodValidated) {
      displayAlert("Period");
    } else {
      dispatch(getScenarioAuditReport(obj));
      dispatch(setState("showScenarioAuditData", true));
    }
  };

  const exportDataAsFile = async (isPdf) => {
    const obj = {
      isPdf,
      selectedCountry,
      selectedScenarioName,
      selectedPeriod,
      exportData: generateExportData(),
      exportTab : "Modification_In_Scenario"
    };
    //console.log("The object inside exportDataAsFile",obj);
    dispatch(ExportAuditData(obj));
  };

  return (
    <Box sx={{ mt: 3 }}>
        <Box>
            <Backdrop
              sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={isLoading}
            >
              <CircularProgress />
            </Backdrop>
        </Box>

      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <FormControl>
            <InputLabel>Country</InputLabel>
            <Select
              value={selectedCountry}
              label="Country"
              style={{ width: "300px" }}
              sx={{ color: "black.main", mt: 1 }}
              onChange={setCountry}
            >
              {countries.map((country, index) => (
                <MenuItem key={index} value={country.countryName}>
                  {country.countryName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          <FormControl>
            <InputLabel>Scenario</InputLabel>
            <Select
              value={selectedScenarioID}
              label="Scenario"
              style={{ width: "300px" }}
              sx={{ color: "black.main", mt: 1 }}
              onChange={setScenario}
            >
              {(selectedCountryID ? scenarios :[])?.map((scenario, index) => (
                <MenuItem key={index} value={scenario.scenarioID}>
                  {scenario.scenarioName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          <FormControl>
            <InputLabel>Period</InputLabel>
            <Select
              value={selectedPeriod}
              label="Period"
              style={{ width: "300px" }}
              sx={{ color: "black.main", mt: 1 }}
              onChange={setPeriod}
            >
              {periods?.map((period, index) => (
                <MenuItem key={index} value={period.value}>
                  {period.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item sx={{ flexGrow: 1 }}>
          <CustomButton onClick={handleDisplay} size="large" style={{ width: "100px", height: "42px" }}>
            Search
          </CustomButton>
        </Grid>

        {showOrHideExport && (
          <Grid item>
            <Box display="flex" alignItems="center">
              <IconButton onClick={() => exportDataAsFile(false)}>
                <GridOnIcon sx={{ color: "green.main" }} />
              </IconButton>
              <IconButton onClick={() => exportDataAsFile(true)}>
                <PictureAsPdfIcon sx={{ color: "red.main" }} />
              </IconButton>
            </Box>
          </Grid>
        )}
      </Grid>

      {alert.alertDisplay && <Alert message={alert.alertMessage} severity={alert.alertSeverity} />}

      {showScenarioAuditData && (
        <Box  mt={4}
          sx={{
            width: "100%",
            minHeight: "200px",
          }}>

          <DataGrid
            disableColumnMenu
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "grey.lighter",
              },
              "& .MuiDataGrid-cell": {
                whiteSpace: "normal !important",
                wordWrap: "break-word !important",
                padding: "10px",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiDataGrid-row": {
                minHeight: "65px !important",
              },
              "& .MuiDataGrid-overlay": {
                zIndex: 10,
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: "1rem",
                color: "#888",
              },
            }}
            style={{
              maxHeight: "calc(100vh - 130px)",
              position: "relative",
            }}
            rows={scenarioAuditReports || []}
            getRowId={(row) => row?.id}
            columns={columns}
            getRowHeight={() => "auto"}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20, 50, 100]}
            disableRowSelectionOnClick
          />
        </Box>
      )}
      {/* Modal Popup for Previous & Modified Values */}
      <Modal open={openModal} onClose={handleClose}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: 600,maxHeight:500, bgcolor: "background.paper", p: 4, boxShadow: 24, borderRadius: 2 ,overflowY:"auto"}}>
          <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
            {modalTitle}
          </Typography>
          <hr style={{ border: "1px solid #ddd", width: "100%", marginBottom: "10px" }} />
          <Box sx={{ maxHeight: 300, overflowY: "auto" }}>
            {filteredLogs.length > 0 ? (
              filteredLogs.map((log, index) => (
                <Typography key={index} variant="body1" sx={{ mb: 1 }}>
                  { infoColumn === "modified" ? log.modifiedValue : log.previousValue}
                </Typography>
              ))
            ) : (
              <Typography variant="body2" color="textSecondary">
                No values found.
              </Typography>
            )}
          </Box>

          <Box sx={{ textAlign: "right", mt: 2, pt: 1, borderTop: "1px solid #ddd" }}>
            <Typography variant="body2" fontWeight="bold">
              Total Count: {filteredLogs.length}
            </Typography>
         </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ModificationInScenario;